// webpacker.ymlのresolved_pathsに指定したプレフィックスは省略可能

// Vue.js
import Vue from "vue/dist/vue.esm";

// /components/surveys
import ConfirmModal from "components/surveys/ConfirmModal.vue";
import SingleSelectionButtonsWithLabel from "components/surveys/SingleSelectionButtonsWithLabel.vue";
import TextArea from "components/surveys/TextArea.vue";
import TextBox from "components/surveys/TextBox.vue";

export default new Vue({
  el: "#vue-app",
  components: {
    ConfirmModal,
    SingleSelectionButtonsWithLabel,
    TextArea,
    TextBox
  },
  methods: {
    openModal(modalId) {
      $(modalId).modal();
    }
  }
});
